// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1GHI1","label":"CategoryService_label__pjt1Z","location":"CategoryService_location__RBIxU"};